import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/CardsSection.css";
import Cards1 from "./cards/Cards1.js";
import Cards2 from "./cards/Cards2.js";
import Cards3 from "./cards/Cards3.js";
import Cards4 from "./cards/Cards4.js";
import Cards5 from "./cards/Cards5.js";
import Cards6 from "./cards/Cards6.js";
import Cards7 from "./cards/Cards7.js";
import Cards8 from "./cards/Cards8.js";
import Cards9 from "./cards/Cards9.js";
import Cards10 from "./cards/Cards10.js";
import Cards11 from "./cards/Cards11.js";

import ServButton from "./ServButton.js";

const CardsSection = () => {
  const { t } = useTranslation();
  const [activeButton, setActiveButton] = useState(1);

  useEffect(() => { }, [activeButton]);
  const handleButtonClick = (buttonIndex) => {
    setActiveButton(buttonIndex);
  };

  return (
    <div>
      <section id="services" className="services">
        <h2 className="wow animate__animated animate__fadeInUp">
          {t("ourServices")}
        </h2>
        <div
          className="servtext wow animate__animated animate__fadeInUp"
          data-wow-delay="0.2s"
        >
          <span>{t("serviceDescription")}</span>
          <span className="orange">{t("freeTestOffer")}</span>
        </div>

        <div
          className="services-buttons wow animate__animated animate__fadeIn"
          data-wow-delay="0.4s"
        >
          <div className="row buttons-row">
            <ServButton
              hot = ' '
              // discount='20' 
              label={t(`shilling`)}
              // discount={10}
              onClick={() => handleButtonClick(1)}
              isActive={activeButton === 1}
            />
            <ServButton
              hot = ' '
              // discount='20' 
              label={t(`traffic`)}
              // discount={10}
              onClick={() => handleButtonClick(11)}
              isActive={activeButton === 11}
            />
            <ServButton
              // hot = ' '
              label={t(`groceHacking`)}
              // discount={20}
              onClick={() => handleButtonClick(2)}
              isActive={activeButton === 2}
            />
            
          </div>
          <div className="row buttons-row">
          <ServButton
              label={t(`otherServices`)}
              onClick={() => handleButtonClick(3)}
              isActive={activeButton === 3}
            />
            <ServButton
              label={t(`activities`)}
              onClick={() => handleButtonClick(6)}
              isActive={activeButton === 6}
            />
            <ServButton
              label={t(`ambassadorProgramCreation`)}
              onClick={() => handleButtonClick(4)}
              isActive={activeButton === 4}
            />
            <ServButton
              label={t(`cmRulling`)}
              onClick={() => handleButtonClick(5)}
              isActive={activeButton === 5}
            />
            <ServButton
              label={t(`visual`)}
              onClick={() => handleButtonClick(8)}
              isActive={activeButton === 8}
            />
            <ServButton
              label={t(`infMarketing`)}
              onClick={() => handleButtonClick(7)}
              isActive={activeButton === 7}
            />
            <ServButton
              label={t(`tdcf`)}
              onClick={() => handleButtonClick(9)}
              isActive={activeButton === 9}
            />
            <ServButton
              label={t(`motionDesign`)}
              onClick={() => handleButtonClick(10)}
              isActive={activeButton === 10}
            />


          </div>
        </div>
      </section>
      <div className="wow animate__animated animate__fadeInUp">
        {activeButton === 1 && <Cards1 key="1" />}
        {activeButton === 2 && <Cards2 key="2" />}
        {activeButton === 3 && <Cards3 key="3" />}
        {activeButton === 4 && <Cards4 key="4" />}
        {activeButton === 5 && <Cards5 key="5" />}
        {activeButton === 6 && <Cards6 key="6" />}
        {activeButton === 7 && <Cards7 key="7" />}
        {activeButton === 8 && <Cards8 key="8" />}
        {activeButton === 9 && <Cards9 key="9" />}
        {activeButton === 10 && <Cards10 key="10" />}
        {activeButton === 11 && <Cards11 key="11" />}
      </div>
    </div>
  );
};

export default CardsSection;
